// extracted by mini-css-extract-plugin
export default {"key-row-selected":"PageTypesSettings_key-row-selected__ki4I0","keyRowSelected":"PageTypesSettings_key-row-selected__ki4I0"};